import { Navigate, useLocation } from "react-router-dom";
import { useAuth, dashboardPathForRole } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
    const { user, status } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                className="min-h-screen flex items-center justify-center"
                data-testid="protected-route-loading"
                style={{ color: "var(--st-ink-muted)" }}
            >
                <span className="tracking-caps text-xs">Verifying session…</span>
            </div>
        );
    }

    if (status !== "yes" || !user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        return <Navigate to={dashboardPathForRole(user.role)} replace />;
    }

    return children;
}
